
import { Toaster } from 'sonner';
import { Suspense, useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";

function FallbackUI() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
        <p className="text-gray-500">Loading application...</p>
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    // Log when App component mounts
    console.log("App component mounted", {
      currentPath: window.location.pathname,
      currentSearch: window.location.search
    });
    
    return () => {
      console.log("App component unmounted");
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Suspense fallback={<FallbackUI />}>
        <AppRoutes />
      </Suspense>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
